import { auth } from "@/plugins/firebase"
import router from "@/router"
import { ga } from "@/main"

const state = {
    user: false
}
const mutations = {
    SET_USER: function (state, user) {
        state.user = user;
    }
}
const actions = {
    listenToLogin: function ({ dispatch }) {
        auth.onAuthStateChanged((user) => {
            if (user) {
                dispatch("setUser", user);
            } else {
                dispatch("setUser", false);
            }
        });
        dispatch("notifications/listenForTokenRefresh", null, { root: true });
        dispatch("notifications/listenForNotification", null, { root: true });
    },
    setUser: async function ({ commit, dispatch, rootState }, user) {
        commit("SET_USER", user);
        if (user) {
            await dispatch("db/bindUser", user.uid, { root: true });
            dispatch("notifications/setMessagingToken", null, { root: true });
            if (!rootState.db.user.doneSetup && router.currentRoute.name != "setup")
                router.push({ name: "setup" });
            else if (router.currentRoute.name != "home")
                router.push({ name: "home" });
                ga.event('Auth', 'login')
        } else {
            await dispatch("db/unBindUser", null, { root: true })
            ga.event('Auth', 'logout')
        }
    },
    logout: async function () {
        await auth.signOut();
        ga.event('Auth', 'logout')
    }
}
const getters = {

}

export default {
    state,
    mutations,
    actions,
    getters
}